module.exports = __webpack_public_path__ + "img/icon_name_card.577e24e7.png";